import React, {useLayoutEffect, useState} from "react";

import {useAppState} from "@stores/AppStateContext";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import {Lightbox} from "yet-another-react-lightbox";

import {CloseIcon} from "../../../components/icons/CloseIcon";
import {ZoomInIcon} from "../../../components/icons/ZoomInIcon";
import {ZoomOutIcon} from "../../../components/icons/ZoomOutIcon";
import {FullscreenIcon} from "../../../components/icons/FullscreenIcon";
import {FullscreenExitIcon} from "../../../components/icons/FullscreenExitIcon";
import {DownloadIcon} from "../../../components/icons/DownloadIcon";
import {ChevronRightIcon} from "../../../components/icons/ChevronRightIcon";
import {ChevronLeftIcon} from "../../../components/icons/ChevronLeftIcon";
import {DeleteIcon} from "../../../components/icons/DeleteIcon";

import {MODALS} from "../modal-names";
import {screenSizeProvider} from "@stores/ScreenSizeProvider";


import "./LightBoxModal.css"


export interface LightBoxModalProps {

    onClose: () => void;
    onRemove?: (i: number) => void;
    images: { src: string; alt?: string }[];
    initialIndex?: number;
}

export const LightBoxModal = (
    {
        onClose,
        images,
        onRemove,
        initialIndex = 0,
    }: LightBoxModalProps
) => {
    const appState = useAppState();
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const isMobile = screenSizeProvider.view !== 'desktop';

    useLayoutEffect(() => {
        if (currentIndex > images.length - 1) {
            setCurrentIndex(0);
        }
    }, [images, currentIndex]);

    return (
        <Lightbox
            open={appState.topModal === MODALS.LIGHTBOX}
            close={onClose}
            slides={images}
            index={currentIndex}
            carousel={{preload: 10, finite: true}}
            fullscreen={{auto: false}}
            toolbar={{
                buttons: isMobile && onRemove ? [
                    <button
                        key="deleteIcon"
                        type="button"
                        className="yarl__button"
                        onClick={() => onRemove(currentIndex)}
                    >
                        <DeleteIcon size={24}/>
                    </button>,
                    "close"
                ] : ["close"],
            }}
            on={{ view: ({ index: currentIndex }) => setCurrentIndex(currentIndex) }}
            plugins={[Thumbnails, Captions, Zoom, Fullscreen, Download]}
            render={{
                iconClose: () => <CloseIcon size={24}/>,
                iconZoomIn: () => <ZoomInIcon size={24}/>,
                iconZoomOut: () => <ZoomOutIcon size={24}/>,
                iconEnterFullscreen: () => <FullscreenIcon size={24}/>,
                iconExitFullscreen: () => <FullscreenExitIcon size={24}/>,
                iconDownload: () => <DownloadIcon size={24}/>,
                iconNext: () => <ChevronRightIcon className="LightBox__ChevronsIcon theme-dark" size={16}
                                                  additionalPadding={8}/>,
                iconPrev: () => < ChevronLeftIcon className="LightBox__ChevronsIcon theme-dark" size={16}
                                                  additionalPadding={8}/>
            }}
            className="my-lightbox-theme"
            captions={{}}
            zoom={{
                maxZoomPixelRatio: 1,
                doubleClickMaxStops: 1,
                scrollToZoom: true,

            }}
            thumbnails={{
                position: "bottom",
                width: 80,
                height: 80,
                border: 0,
                borderStyle: "solid",
                borderColor: "#888",
                borderRadius: 6,
                padding: 0,
                gap: 8,
                imageFit: "cover",
                vignette: false,
            }}
        />
    );
};
